var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlockchainGoose = function SvgBlockchainGoose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 77.5,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 68.5713,
    width: 7.14284,
    height: 14.6428,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6426,
    y: 73.9277,
    width: 57.1427,
    height: 8.92855,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2144,
    y: 68.5713,
    width: 32.1428,
    height: 8.92855,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 65,
    width: 42.857,
    height: 9.28569,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1432 56.0713H36.0718V59.6431H28.9289V72.143H28.9289V63.2141H20.0003V72.143H14.6431V82.8573H21.786V84.6429H60.1787V82.8573H71.7858V77.5H75.3573V66.7858H70.0002V59.6431H52.1432V56.0713Z",
    fill: "#1FA6FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 61.4277,
    width: 17.8571,
    height: 9.28569,
    fill: "#1FA6FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 22.1426,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0713,
    y: 54.2852,
    width: 14.2857,
    height: 1.78571,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9287,
    y: 57.8574,
    width: 5.35713,
    height: 1.78571,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6431,
    y: 70.3574,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 68.5713,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 14.6426,
    y: 81.0713,
    width: 7.14284,
    height: 1.78571,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 88.2139,
    width: 46.4284,
    height: 1.78571,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 61.4277,
    width: 5.35713,
    height: 1.78571,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 32.8574,
    width: 8.92855,
    height: 1.78571,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 40,
    width: 12.5,
    height: 1.78571,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 24.8213,
    width: 1.78571,
    height: 5.35713,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 34.2856,
    y: 56.0713,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 82.8574,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 12.8569,
    y: 72.1426,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 27.1431,
    y: 59.6426,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 30.1777,
    width: 1.78571,
    height: 5.35713,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 29.2852,
    width: 1.78571,
    height: 28.5714,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 41.7852,
    width: 1.78571,
    height: 21.4285,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 61.4277,
    width: 3.57142,
    height: 1.78571,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 66.7852,
    width: 1.78571,
    height: 5.35713,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 72.1426,
    width: 32.1428,
    height: 1.78571,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 63.2139,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 65,
    width: 3.57142,
    height: 1.78571,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5713,
    y: 77.5,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 75.3569,
    y: 66.7852,
    width: 1.78571,
    height: 10.7143,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 63.2139,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 71.7856,
    y: 77.5,
    width: 1.78571,
    height: 5.35713,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 80.7144,
    y: 34.6426,
    width: 1.78571,
    height: 7.14284,
    fill: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 28.3926,
    width: 16.0714,
    height: 31.2499,
    fill: "#514E4E"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 24.8213,
    width: 14.2857,
    height: 10.7143,
    fill: "#302E2E"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 34.6426,
    width: 14.2857,
    height: 7.14284,
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 23.9277,
    width: 14.2857,
    height: 10.7143,
    fill: "#514E4E"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 34.6426,
    width: 14.2857,
    height: 5.35713,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 59.2856,
    y: 30.1777,
    width: 10.7143,
    height: 7.14284,
    fill: "#514E4E"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 29.2852,
    width: 3.57142,
    height: 5.35713,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 29.2852,
    width: 1.78571,
    height: 1.78571,
    fill: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 53.9287,
    y: 59.6426,
    width: 14.2857,
    height: 1.78571,
    fill: "#0270B9"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4287,
    y: 73.9277,
    width: 8.92855,
    height: 3.57142,
    fill: "#FFFEFD"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 82.8574,
    width: 8.92855,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 79.2852,
    width: 1.78571,
    height: 3.57142,
    fill: "#FFFEFD"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 82.8574,
    width: 46.4284,
    height: 1.78571,
    fill: "#FFFEFD"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70.3574,
    width: 30.3571,
    height: 1.78571,
    fill: "#0270B9"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 82.8574,
    width: 33.9285,
    height: 1.78571,
    fill: "#0270B9"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 86.4277,
    width: 46.4284,
    height: 1.78571,
    fill: "#BABABA"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 21.9644,
    y: 84.6426,
    width: 46.4284,
    height: 1.78571,
    fill: "#EAEAEA"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7144,
    y: 81.0713,
    width: 7.14284,
    height: 1.78571,
    fill: "#0270B9"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 72.1426,
    width: 7.14284,
    height: 1.78571,
    fill: "#0270B9"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 61.0713,
    y: 77.5,
    width: 1.78571,
    height: 3.57142,
    fill: "#0270B9"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 48.5713,
    y: 66.7852,
    width: 1.78571,
    height: 3.57142,
    fill: "#0270B9"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 50.3569,
    y: 63.2139,
    width: 1.78571,
    height: 3.57142,
    fill: "#0270B9"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 63.2139,
    width: 3.57142,
    height: 5.35713,
    fill: "#0270B9"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 68.5713,
    width: 1.78571,
    height: 3.57142,
    fill: "#0270B9"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 57.8574,
    width: 1.78571,
    height: 5.35713,
    fill: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 75.7139,
    width: 5.35713,
    height: 5.35713,
    fill: "#0270B9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 75.7139,
    width: 3.57142,
    height: 1.78571,
    fill: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 9.28564,
    y: 79.2852,
    width: 5.35713,
    height: 1.78571,
    fill: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1426,
    y: 24.8213,
    width: 1.78571,
    height: 4.46427,
    fill: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 21.7856,
    y: 84.6426,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 64.6426,
    y: 77.5,
    width: 7.14284,
    height: 5.35713,
    fill: "#FFFEFD"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 82.8574,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 82.8574,
    width: 1.78571,
    height: 5.35713,
    fill: "black"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2144,
    y: 73.9277,
    width: 3.57142,
    height: 1.78571,
    transform: "rotate(90 68.2144 73.9277)",
    fill: "#0270B9"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8569,
    y: 77.5,
    width: 3.57142,
    height: 1.78571,
    fill: "#0270B9"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 63.2139,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2144,
    y: 66.7852,
    width: 1.78571,
    height: 1.78571,
    fill: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4287,
    y: 68.5713,
    width: 1.78571,
    height: 3.57142,
    fill: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8926,
    y: 1.78516,
    width: 10.7143,
    height: 14.2857,
    fill: "#1FA6FF"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8926,
    width: 10.7143,
    height: 1.78571,
    fill: "#141425"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6069,
    y: 17.8574,
    width: 10.7143,
    height: 1.78571,
    transform: "rotate(-180 66.6069 17.8574)",
    fill: "#141425"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 54.1069,
    y: 1.78516,
    width: 1.78571,
    height: 1.78571,
    fill: "#141425"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 68.3926,
    y: 16.0713,
    width: 1.78571,
    height: 1.78571,
    transform: "rotate(-180 68.3926 16.0713)",
    fill: "#141425"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3213,
    y: 3.57129,
    width: 1.78571,
    height: 10.7143,
    fill: "#141425"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 68.3926,
    y: 3.57129,
    width: 1.78571,
    height: 10.7143,
    fill: "#141425"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6069,
    y: 1.78516,
    width: 1.78571,
    height: 1.78571,
    fill: "#141425"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8926,
    y: 16.0713,
    width: 1.78571,
    height: 1.78571,
    transform: "rotate(-180 55.8926 16.0713)",
    fill: "#141425"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 54.1069,
    y: 3.57129,
    width: 1.78571,
    height: 10.7143,
    fill: "#1FA6FF"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6069,
    y: 3.57129,
    width: 1.78571,
    height: 10.7143,
    fill: "#1FA6FF"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6787,
    y: 3.57129,
    width: 7.14284,
    height: 1.78571,
    fill: "#1574B3"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8926,
    y: 5.35742,
    width: 1.78571,
    height: 7.14284,
    fill: "#1574B3"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 54.1069,
    y: 12.5,
    width: 1.78571,
    height: 1.78571,
    fill: "#1574B3"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 55.8926,
    y: 14.2852,
    width: 8.92855,
    height: 1.78571,
    fill: "#1574B3"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6787,
    y: 12.501,
    width: 7.14284,
    height: 1.78571,
    fill: "#ECF7FF"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 59.4644,
    y: 1.78613,
    width: 7.14284,
    height: 1.78571,
    fill: "#ECF7FF"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 66.6074,
    y: 3.57129,
    width: 1.78571,
    height: 1.78571,
    fill: "#ECF7FF"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8213,
    y: 5.3584,
    width: 1.78571,
    height: 7.14284,
    fill: "#ECF7FF"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 60.417,
    y: 6.60742,
    width: 2.97619,
    height: 0.892856,
    fill: "#ECF7FF"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9287,
    y: 6.60742,
    width: 1.48809,
    height: 1.78571,
    fill: "#ECF7FF"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 60.417,
    y: 8.39258,
    width: 1.48809,
    height: 0.892856,
    fill: "#ECF7FF"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 60.417,
    y: 5.71484,
    width: 1.48809,
    height: 0.892856,
    fill: "#ECF7FF"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 61.9048,
    y: 9.28613,
    width: 1.48809,
    height: 1.78571,
    fill: "#ECF7FF"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9287,
    y: 10.1797,
    width: 2.97619,
    height: 0.892856,
    fill: "#ECF7FF"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 60.417,
    y: 11.0723,
    width: 1.48809,
    height: 0.892856,
    fill: "#ECF7FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlockchainGoose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blockchainGoose.f453944b.svg";
export { ForwardRef as ReactComponent };